import { CaseFormModel } from "./case-form.model";

export class SaveCaseRequestModel extends CaseFormModel {
    constructor(values?: Partial<SaveCaseRequestModel>) {
        super(values);
        Object.assign(this, values);
    }
    
    public static parseValues(json: any) {
        if(!json) {
            return new SaveCaseRequestModel();
        }
        
        let caseFormModel = CaseFormModel.parseValues(json);
        const responseDetails = {
        };
        
        Object.assign(responseDetails, caseFormModel);
        return new SaveCaseRequestModel(responseDetails);
    }
}
